import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Collapse,
  Grid,
  InputLabel,
  Snackbar,
  TextField,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import PickupLine from "../../../Components/Warehouse/PickupLine";
import TableComponentPickup from "../../Warehouse1/TableComponentPickup";

import {
  Add,
  ArrowForward,
  DoneAll,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import NotifyOrder from "../NotifyOrder";
import httpclient from "../../../utilsFulfill";
import MuiAlert from "@mui/material/Alert";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment/moment";
import featureServer from "../../../FeatureServer/featureServer";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SearchBox = styled(Box)(({ theme }) => ({
  "& input": {
    // padding: "12px",
    width: "100%",
  },
}));

const columns = [
  // { id: "check", name: " " },
  { id: "imageUrl", name: "Image" },
  { id: "itemname", name: "Item" },
  { id: "EANBarcode", name: "Bar Code" },
  //{ id: "code", name: "Code" },
  { id: "SizeID", name: "Size" },

  { id: "releasestatus", name: "Release Status" },
  { id: "wmslocationid", name: "Location" },
  { id: "quantity", name: "Quantity" },
  { id: "confirm", name: "Confirm" },
  // { id: "action", name: "Action" },
];

const PickupList = ({
  pickupList,
  loading,
  pickupOrder,
  order,
  setOrder,
  setValue,
  orderList,
  orderName,
  setOrderName,
  handleOrderFilter,
  handleChangeOrder,
  handleOrderCodeFilter,
  handlePrintTaxInvoice,
  snackMessage1,
  open1,
  setOpen1,
  snackStatus1,
  orderCode,
  setOrderCode,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();

  //const [orderCode, setOrderCode] = useState("");
  const [codeName, setCodeName] = useState("");
  const [codeErr, setCodeErr] = useState(false);
  const [pickID, setPickID] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  var [modifiedData, setModifiedData] = useState([]);
  var [modifiedDataList, setModifiedDataList] = useState([]);

  const [check, setCheck] = useState(false);
  const [showNotifyDialog, setShowNotifyDialog] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  var [fulfillState, setFulFillState] = useState(false);
  var [partialfulfillState, setPartialFulFillState] = useState(false);
  const [partiallyFulfilledIDs, setPartiallyFulFilledIDs] = useState(null);
  const [partiallyFulfilledQuantities, setPartiallyFulfilledQuantities] = useState(null);
  const [open, setOpen] = useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [dataModified, setDataModified] = useState(false);
  const [collectionLoading, setCollectionLoading] = useState(false);
  //Mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // console.log("filter data", filteredData);
  //console.log("pickupOrder", pickupOrder);

  useState(() => {
    setOpenFilter(false);
  }, []);

  useEffect(() => {
    var allData = [];
    pickupList &&
      pickupList.map((pick) => {
        var newData = {
          productQuantity: 0,
          check: false,
          id: pick.id,
          location: pick.wmslocationid,
        };
        allData.push(newData);
      });
    setModifiedData(allData);
    setFilteredData(pickupList);
  }, [pickupList]);

  useEffect(() => {
    getFulfilledState();
    getModifiedState();
  }, [modifiedData, modifiedDataList]);

  // const getFulfilledState = () => {
  //   if (modifiedData.length > 0) {
  //     for (let i = 0; i < pickupList.length; i++) {
  //       let modAmt = parseInt(pickupList[i].linenum || pickupList[i].actual_total_lines);
  //       if (
  //         pickupList[i].id !== modifiedData[i].id ||
  //         modAmt !== modifiedData[i].productQuantity
  //       ) {
  //         return setFulFillState(false);
  //       } else if (
  //         pickupList[i].id !== modifiedData[i].id ||
  //         modAmt !== modifiedData[i].productQuantity
  //       ) {
  //         return setPartialFulFillState(true);
  //       }  else {
  //         setFulFillState(true);
  //       }
  //     }
  //   }
  // };



  // const getFulfilledState = () => {
  //   let fulfilled = true;
  //   let partiallyFulfilled = false;
  //   let allModifiedZero = true;
  //   const partiallyFulfilledIds = [];
  //   if (modifiedData.length > 0) {
  //     for (let i = 0; i < pickupList.length; i++) {
  //       let modAmt = parseInt(pickupList[i].actual_total_lines);
  //       if (modifiedData[i].productQuantity !== modAmt) {
  //         fulfilled = false;
  //         partiallyFulfilled = true;
  //         partiallyFulfilledIds.push(modifiedData[i].id);
  //       }
  //       if (modifiedData[i].productQuantity !== 0) {
  //         allModifiedZero = false;
  //       }
  //     }
  //   } else {
  //     fulfilled = false;
  //   }

  //   if (allModifiedZero) {
  //     setPartialFulFillState(false);
  //   } else if (fulfilled) {
  //     setFulFillState(true);
  //     setPartialFulFillState(false);
  //     setPartiallyFulFilledIDs(null);
  //     setPartiallyFulfilledQuantities(null);
  //   } else if (partiallyFulfilled) {
  //     setFulFillState(false);
  //     setPartialFulFillState(true);
  //     // const remainingIds = modifiedData.filter(item => !partiallyFulfilledIds.includes(item.id)).map(item => item.id).join(','); // Filter out partially fulfilled IDs and join remaining IDs
  //     const remainingIds = modifiedData
  //       .filter(item => partiallyFulfilledIds.includes(item.id) && item.productQuantity !== 0)
  //       .map(item => item.id)
  //       .join(',');
  //     setPartiallyFulFilledIDs(remainingIds);
  //     // const remainingQtys = modifiedData.filter(item => !partiallyFulfilledQuantities.includes(item.productQuantity)).map(item => item.productQuantity).join(','); // Filter out partially fulfilled IDs and join remaining IDs
  //     const remainingQtys = modifiedData
  //     .filter(item => partiallyFulfilledIds.includes(item.id) && item.productQuantity !== 0)
  //     .map(item => item.productQuantity)
  //     .join(',');
  //     setPartiallyFulfilledQuantities(remainingQtys);
  //   }
  // };

  const getFulfilledState = () => {
    let fulfilled = true;
    let partiallyFulfilled = false;
    let allModifiedZero = true;
    const fulfilledIds = [];
    const fulfilledQuantities = [];
    const partiallyFulfilledIds = [];
    const partiallyFulfilledQuantities = [];

    if (modifiedData.length > 0) {
      for (let i = 0; i < modifiedData.length; i++) {
        //const modAmt = parseInt(pickupList[i].actual_total_lines) - parseInt(pickupList[i].totalFulfilledQty);
        const modAmt = parseInt(pickupList[i].quantity);
        const modifiedQty = modifiedData[i].productQuantity;

        if (modifiedQty !== modAmt || order.isPartialFulfilled === 1) {
          fulfilled = false;
          partiallyFulfilledIds.push(modifiedData[i].id);
          partiallyFulfilledQuantities.push(modifiedQty);
          partiallyFulfilled = true; // Row is now partially fulfilled
        } else {
          fulfilledIds.push(modifiedData[i].id);
          fulfilledQuantities.push(modifiedQty);
        }

        if (modifiedQty !== 0) {
          allModifiedZero = false;
        }
      }
    } else {
      fulfilled = false;
    }

    if (allModifiedZero) {
      setPartialFulFillState(false);
    } else if (fulfilled) {
      setFulFillState(true);
      setPartialFulFillState(false);
      setPartiallyFulFilledIDs(null);
      setPartiallyFulfilledQuantities(null);
    } else if (partiallyFulfilled) {
      setFulFillState(false);
      setPartialFulFillState(true);
      // const remainingIds = modifiedData.filter(item => !partiallyFulfilledIds.includes(item.id)).map(item => item.id).join(','); // Filter out partially fulfilled IDs and join remaining IDs
      const remainingIds = modifiedData
        .filter(item => partiallyFulfilledIds.includes(item.id) && item.productQuantity !== 0)
        .map(item => item.id)
        .join(',');
      setPartiallyFulFilledIDs(remainingIds);
      // const remainingQtys = modifiedData.filter(item => !partiallyFulfilledQuantities.includes(item.productQuantity)).map(item => item.productQuantity).join(','); // Filter out partially fulfilled IDs and join remaining IDs
      const remainingQtys = modifiedData
        .filter(item => partiallyFulfilledIds.includes(item.id) && item.productQuantity !== 0)
        .map(item => item.productQuantity)
        .join(',');
      setPartiallyFulfilledQuantities(remainingQtys);
    }

    fulfilledIds.forEach(id => {
      setPartiallyFulFilledIDs(prevIds => prevIds ? prevIds + ',' + id : id);
    });

    fulfilledQuantities.forEach(qty => {
      setPartiallyFulfilledQuantities(prevQtys => prevQtys ? prevQtys + ',' + qty : qty);
    });
  };

  // console.log("partially fulfilled ids", partiallyFulfilledIDs);
  // console.log("partially fulfilled quantities", partiallyFulfilledQuantities);

  const getModifiedState = () => {
    if (modifiedData.length > 0) {
      modifiedData.map((mod, index) => {
        if (mod.productQuantity > 0) {
          setDataModified(true);
        }
      });
    }
  };

  // console.log("fulfill state is: fulfillState, partialfulfillState", fulfillState, partialfulfillState);

  const handleChange = (e, pick) => {
    let currValue;

    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.id) {
        if (e.target.value <= 0) {
          currValue = 0;
        }
        //else if (e.target.value >= parseInt(pick.actual_total_lines) - parseInt(pick.totalFulfilledQty)) 
        //currValue = parseInt(pick.actual_total_lines) - parseInt(pick.totalFulfilledQty);
        else if (e.target.value >= parseInt(pick.quantity)) {
          currValue = parseInt(pick.quantity);
        } else {
          currValue = e.target.value;
        }
        return (mod.productQuantity = parseInt(currValue));
      }
    });

    setModifiedDataList(res);

    getFulfilledState();
  };

  const handleChangeLocation = (e, pick) => {
    let currValue;

    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.id) {

        currValue = e.target.value;

        return (mod.location = currValue);
      }
    });

    setModifiedDataList(res);
  };

  const handleAddQuantity = (pick) => {
    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.id) {
        return (mod.productQuantity =
          //parseInt(pick?.actual_total_lines) - parseInt(pick?.totalFulfilledQty) == mod.productQuantity
          parseInt(pick?.quantity) == mod.productQuantity
            ? mod.productQuantity
            : mod.productQuantity + 1);
      }
    });

    setModifiedDataList(res);

    getFulfilledState();
  };

  const handleRemoveQuantity = (pick) => {
    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.id) {
        return (mod.productQuantity =
          mod.productQuantity > 0 ? mod.productQuantity - 1 : 0);
      }
    });

    setModifiedDataList(res);

    getFulfilledState();
  };

  const handleChangeOrderCode = (e) => {
    setOrderCode(e.target.value);
  };

  const handleChangeOrderEnter = (e) => {
    if (e.key === "Enter") {
      handleOrderCodeFilter(e.target.value);
    }
  };

  const handleOrderSubmit = (e) => {
    handleOrderCodeFilter(orderCode);
  };

  const handleChangeCode = (e) => {
    setCodeName(e.target.value);
  };

  const handleChangeEnter = (e) => {
    if (e.key === "Enter") {
      setCodeName(e.target.value);
      handleAdd();
    }
  };

  const handleAdd = () => {
    pickupList.map((pick) => {
      if (codeName === pick.code || codeName === pick.ax_details?.EANBarcode) {
        var res = modifiedData.filter((mod) => {
          if (mod.id == pick.id) {
            if (
              //mod.productQuantity === parseInt(pick?.actual_total_lines) - parseInt(pick?.totalFulfilledQty)
              mod.productQuantity === parseInt(pick?.quantity)
            ) {
              const vibrationSoundSrc =
                process.env.PUBLIC_URL + "/vibration.mp3";
              const audio = new Audio(vibrationSoundSrc);
              audio.play();
            }
            return (mod.productQuantity =
              //parseInt(pick?.actual_total_lines) - parseInt(pick?.totalFulfilledQty) == mod.productQuantity
              parseInt(pick?.quantity) == mod.productQuantity
                ? mod.productQuantity
                : mod.productQuantity + 1);
          }
        });

        setModifiedDataList(res);

        getFulfilledState();

        setCodeErr(false);

        setTimeout(() => {
          setCodeName("");
        }, 200);
      } else {
      }
    });
    let codeVals = pickupList.map((pick) => pick.code);
    let barCodes = pickupList.map((pick) => pick.ax_details?.EANBarcode);

    if (barCodes.length) {
      if (barCodes.includes(codeName) || codeVals.includes(codeName) || codeName == "") {
      } else {
        const vibrationSoundSrc = process.env.PUBLIC_URL + "/vibration.mp3";
        const audio = new Audio(vibrationSoundSrc);
        audio.play();

        setCodeErr(true);

        setTimeout(() => {
          setCodeName("");
          setCodeErr(false);
        }, 1500);
      }
    }
  };

  const handlePickupAll = () => {
    var allData = [];

    // pickupList.map((pick) => {
    //   var newData = {
    //     productQuantity: parseInt(pick.amount || pick.quantity),
    //     check: false,
    //     id: pick.id,
    //   };
    //   allData.push(newData);
    // });
    const filterID = filteredData.map((fil) => fil.id);

    pickupList.map((pick, index) => {
      var newData = {
        productQuantity: filterID.includes(pick.id)
          // ? (parseInt(pick.actual_total_lines) - parseInt(pick.totalFulfilledQty))
          ? (parseInt(pick.quantity))
          : 0,
        check: false,
        id: pick.id,
      };
      allData.push(newData);
    });
    setModifiedData(allData);
  };

  // console.log('modified data', modifiedData);

  const handleReady = () => {
    setShowNotifyDialog(true);
    setOrderDetails(order);
  };

  const callbackNotify = (call) => {
    //console.log('call back', call);
    // console.log('orderDetailsorderDetails',orderDetails);
    if (call.open === false && call.success === false) {

      setShowNotifyDialog(false);
      setOrderDetails({});
    }

    if (call.open === false && call.success === true) {
      setShowNotifyDialog(false);
      setCollectionLoading(true);
      httpclient
        .get(
          // orderDetails.customer.email !== "" ||
          //   orderDetails.customer.mobile !== ""
          // ? `wms/fulfill/order?id=${orderDetails.id}&warehouseID=${id}&sendSms=${call.phoneValue ? 1 : 0}&sendEmail=${call.emailValue ? 1 : 0}`
          // : 
          `readyForCollection?&salesDocumentIDs=${orderDetails.id}&isPartialFulfilled=${partialfulfillState === true ? 1 : 0}&partialFulfilledLines=${partiallyFulfilledIDs}&fulfilledQty=${partiallyFulfilledQuantities}&sendSms=${call.phoneValue ? 1 : 0}&sendEmail=${call.emailValue ? 1 : 0}&invoiceOrder=${call.invoiceOrder ? 1 : 0}&printTaxInvoice=${call.printTaxInvoice ? 1 : 0}&emailTaxInvoice=${call.emailTaxInvoice ? 1 : 0}&warehouseID=${id}`
        )
        .then(({ data }) => {
          if (data.success) {
            if (data.status === 200) {

              setCollectionLoading(false);
              setOpen(true);
              setSnackStatus("success");
              setSnackMessage(data.message);
              if (data.records && data.records.receiptUrl) {
                handlePrintTaxInvoice(data.records.receiptUrl);
              }
              setTimeout(() => {
                setOrder([]);
                setModifiedData([]);
                setModifiedDataList([]);
                setFilteredData([]);
                setOrderName("");
                setOrderCode("");
                setSearchText("");
              }, 1500);
            }
          } else {
            setCollectionLoading(false);
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        })
        .catch((error) => {
          setCollectionLoading(false);
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(error);
        });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setOpen1(false);
  };

  const handleSearch1 = (e) => {
    setSearchText(e.target.value);
    var searchValue = e.target.value;

    var filtered = pickupList.filter((order, index) => {
      var itemName = order.itemname;
      return itemName.toLowerCase().match(new RegExp(searchValue, "g"));
    });

    setFilteredData(filtered);
  };

  const handleFilter = () => {
    setOpenFilter(!openFilter);
  };

  const checkDataModifed = (newValue) => {
    if (dataModified) {
      if (
        window.confirm(
          "This order has already been modifed. Are you sure you want to change the order?"
        )
      ) {
        handleOrderFilter(newValue);
        setTimeout(() => {
          setOpenFilter(false);
          setDataModified(false)
        }, 1000);
      }
    }
    else {
      handleOrderFilter(newValue);
      setOpenFilter(false);
    }
  };

  //console.log("pick up data >>>", pickupList);

  // console.log("modified data is", modifiedData);

  // console.log("order12345 >", order);

  return (
    <div>
      <>
        <Box
          display={"flex"}
          alignItems={"center"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          mb={3}
        >
          <Box flex={"1"}>
            {order.salesid === undefined
              ? "Please choose order from filter"
              : ""}
          </Box>
          <Box
            textAlign="center"
            display={"flex"}
            alignItems={"flex-end"}
            justifyContent={"center"}
            style={{ height: "auto", marginTop: "10px" }}
            flex="1"
          >
            {order.salesid === undefined ? (
              <Box display={"flex"}>
                <TextField
                  label="Order Code"
                  variant="outlined"
                  focused
                  // color={codeErr ? "error" : "primary"}
                  type="text"
                  value={orderCode}
                  onChange={handleChangeOrderCode}
                  onKeyDown={handleChangeOrderEnter}
                  fullWidth
                  autoFocus
                  inputProps={{
                    style: {
                      padding: 12,
                      width: 300,
                    },
                  }}
                />
                <Button
                  onClick={handleOrderSubmit}
                  color="primary"
                  variant="contained"
                >
                  Submit
                  {/* <ArrowForward /> */}
                </Button>
              </Box>
              //" "
            ) : (
              <h2>
                {pickupOrder
                  ? `Pickup Order ${order.salesid !== undefined ? "#" + order.salesid : ""
                  }`
                  : "Pickup List"}
              </h2>
            )}
          </Box>
          <Box flex="1" textAlign={"right"}>
            <Button variant="contained" color="primary" onClick={handleFilter}>
              Filter{" "}
              {!openFilter ? (
                <KeyboardArrowDown fontSize="small" />
              ) : (
                <KeyboardArrowUp fontSize="small" />
              )}
            </Button>
          </Box>
        </Box>

        <Collapse in={openFilter}>
          <Box style={{ margin: "0 10px" }}>
            <Grid
              spacing={2}
              container
              style={{
                padding: "20px",
                border: "1px solid #f1f1f1",
                borderRadius: "5px",
                marginBottom: "20px",
              }}
            >
              <Grid item xs={12} md={6}>
                <InputLabel>Search</InputLabel>
                {/* <SearchBox display={"flex"}> */}
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchText"
                  value={searchText}
                  onChange={handleSearch1}
                  // sx={{ width: "300px" }}
                  fullWidth
                />
                {/* </SearchBox> */}
              </Grid>
              <Grid item xs={12} md={6}>
                {pickupOrder ? (
                  <>
                    <InputLabel>Scan/Select Sales ID</InputLabel>
                    <Autocomplete
                      disablePortal
                      inputValue={orderName}
                      options={orderList.length > 0 ? orderList : []}
                      getOptionLabel={(option) => option.salesid}
                      // sx={{ width: isMobile ? 290 : 500 }}
                      onChange={(event, newValue) => {
                        checkDataModifed(newValue);
                      }}
                      autoFocus
                      onFocus={(e) => e.target.select()}
                      // fullWidth
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          value={orderName || ""}
                          onChange={handleChangeOrder}
                          fullWidth
                          focused={openFilter}
                          autoFocus={openFilter}
                        />
                      )}
                    />
                  </>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Box>
        </Collapse>

        {order.salesid === undefined ? (
          ""
        ) : (
          <>
            <Box display={"flex"} mb={3}>
              <TextField
                label="Code"
                variant="outlined"
                focused
                disabled={openFilter}
                color={codeErr ? "error" : "primary"}
                type="text"
                value={codeName}
                onChange={handleChangeCode}
                onKeyDown={handleChangeEnter}
                fullWidth
                autoFocus={openFilter ? false : true}
              />
              <Button variant="contained" color="secondary"
                onClick={handleAdd}
              >
                <Add fontSize="small" style={{ marginRight: "5px" }} /> Add
              </Button>
            </Box>

            {featureServer && (
              <>
                <strong>Order Last Synced:</strong> {moment(order.resyncProcessedTime).format("ddd, MMM Do YYYY, h:mm a")}
              </>
            )}

            <Box textAlign={"right"} mb={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handlePickupAll}
                disabled={pickupList.length === 0 || pickupList.some((pick) => pick.isFulfilled === 1) ? true : false}
              >
                <DoneAll fontSize="small" style={{ marginRight: "5px" }} />{" "}
                Pickup All
              </Button>
            </Box>

            {loading ? (
              <Box textAlign={"center"}>
                <CircularProgress />
              </Box>

            ) : (
              <>
                <TableComponentPickup
                  columns={columns}
                  rows={filteredData || []}
                  handleChange={handleChange}
                  handleChangeLocation={handleChangeLocation}
                  handleAddQuantity={handleAddQuantity}
                  handleRemoveQuantity={handleRemoveQuantity}
                  modifiedData={modifiedData}
                />
              </>
            )}
          </>
        )}
      </>

      {order?.salesid && pickupOrder && (
        <Box mt={2} textAlign={"right"}>
          {collectionLoading ? (
            <CircularProgress color="secondary"
              style={{
                height: "30px",
                width: "30px",
                marginRight: "10px"
              }} />
          )
            :
            (
              <Button
                variant="contained"
                color="primary"
                onClick={handleReady}
                disabled={!fulfillState && !partialfulfillState}
              >
                {/* {order?.customer?.email !== "" || order?.customer?.mobile !== "" ? "Notifiy and Ready to Fulfill" : "Ready to Fulfill"} */}
                {partialfulfillState ? "Ready for partial fulfillment" : "Ready to Fulfill"}
                <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
              </Button>
            )}
        </Box>
      )}
      {showNotifyDialog && (
        <NotifyOrder
          orderDetails={orderDetails}
          callbackNotify={callbackNotify}
        // handlePrintTaxInvoice={handlePrintTaxInvoice}
        />
      )}
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{ width: "100%", position: "relative", top: "40px" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={open1}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus1}
          sx={{ width: "100%", position: "relative", top: "40px" }}
        >
          {snackMessage1}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default PickupList;
